import { Icon } from "@iconify/react/dist/iconify.js";
import {
  openPhraseConfirmToggle,
  openPhraseView,
} from "../../store/reducers/plantels/phrasesByPlantel.reducer";
import { getPhraseByPlantelByIdThunk } from "../../store/reducers/plantels/plantels.thunks";
import { useDispatch } from "react-redux";

export const PhraseActions = ({ phrase }) => {
  const dispatch = useDispatch();

  const handleView = () => {
    dispatch(openPhraseView());
    dispatch(getPhraseByPlantelByIdThunk(phrase.id));
  };

  const handleToggle = () => {
    dispatch(openPhraseConfirmToggle({ id: phrase.id }));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button
            className={itemClass}
            onClick={() => console.log("Edit phrase:", phrase.id)}
          >
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${phrase.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                phrase.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{phrase.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};
